import { createSlice } from "@reduxjs/toolkit";
import { ValuesSelected } from "../dataTable/dataTableFilters";
import { fetchDashboardLocationsFilter } from "../../actions/dashboard/dashboardFiltersAsyncActions";

export interface DashboardFiltersState {
  dataDateActivity: Date[];
  dateRangePickerOpen: boolean;
  locations: {
    valuesSelected: ValuesSelected[];
    allValuesSelected: boolean;
  };
  filtersLocation: string[] | undefined;
  dashboardFilterValues: {
    locations: ValuesSelected[];
    loadingFilters?: boolean;
    errorFilters?: string;
  };
}

const initialState: DashboardFiltersState = {
  dataDateActivity: [
    new Date(new Date().setDate(new Date().getDate() - 7)),
    new Date(new Date().setDate(new Date().getDate())),
  ],
  dateRangePickerOpen: false,
  locations: {
    valuesSelected: [],
    allValuesSelected: true,
  },
  filtersLocation: [],
  dashboardFilterValues: {
    locations: [{ name: "", id: undefined }],
    loadingFilters: false,
    errorFilters: "",
  },
};

export const dashboardFiltersSlice = createSlice({
  name: "dashboardFilters",
  initialState,
  reducers: {
    setDataDateActivity(state, action) {
      state.dataDateActivity = action.payload;
    },
    setDateRangePickerOpen(state, action) {
      state.dateRangePickerOpen = action.payload;
    },
    setLocationValuesSelected(state, action) {
      state.locations.valuesSelected = action.payload;
    },
    setLocationAllValuesSelected(state, action) {
      state.locations.allValuesSelected = action.payload;
    },
    setSelectSites(state, action) {
      const values = action?.payload.map((l) => {
        return l.name;
      });

      return {
        ...state,
        filtersLocation: values,
        locations: {
          ...state.locations,
          valuesSelected: action.payload,
        },
      };
    },

    setSelectAllSitesFilter(state, action) {
      const values = action?.payload.map((l) => {
        return l.name;
      });
      return {
        ...state,
        filtersLocation: values,
        locations: {
          allValuesSelected: true,
          valuesSelected: action.payload,
        },
      };
    },
    resetSelectAllSitesFilter(state) {
      return {
        ...state,
        locations: {
          allValuesSelected: false,
          valuesSelected: [],
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardLocationsFilter.pending, (state) => {
        state.dashboardFilterValues.loadingFilters = true;
        state.dashboardFilterValues.errorFilters = "";
      })
      .addCase(fetchDashboardLocationsFilter.fulfilled, (state, action) => {
        state.dashboardFilterValues.loadingFilters = false;
        state.dashboardFilterValues.locations = action.payload;
      })
      .addCase(fetchDashboardLocationsFilter.rejected, (state, action) => {
        state.dashboardFilterValues.loadingFilters = false;
        state.dashboardFilterValues.locations =
          initialState.dashboardFilterValues.locations;
        state.dashboardFilterValues.errorFilters = action.payload as string;
      });
  },
});

export const {
  setSelectSites,
  setSelectAllSitesFilter,
  resetSelectAllSitesFilter,
  setDataDateActivity,
  setDateRangePickerOpen,
  setLocationValuesSelected,
  setLocationAllValuesSelected,
} = dashboardFiltersSlice.actions;

export const DashboardFiltersReducer = dashboardFiltersSlice.reducer;
